import styled, {css} from "styled-components";
import {LOBBY_PAGE} from "../../../themes/css-global-classes";

export interface IBannerContainerBoxProps {
  minHeight?: string;
}

export const BannerContainerDefaultBox = styled.div<IBannerContainerBoxProps>`
  position: relative;
  width: 100%;
  overflow-x: hidden;

  .${LOBBY_PAGE} & {
    z-index: 2;
    background-color: ${props => props.theme.colors.background}
  }

  ${props => props.minHeight && css`
    min-height: ${props.minHeight};
`};
`;
